const apiUrl = process.env.REACT_APP_API_URL;
export const PutProjectesIdAlumnesIdTascaId = async ( id_alumne : string, id_projecte : string, id_tasca : number,
                                             aval : string, observ : string, ordre : number, id_grup : string) => {

    try {
        const response =
                await fetch(`${apiUrl}:8061/projectes/${id_projecte}/alumnes/${id_alumne}/tasca/${id_tasca}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                 avaluacio: aval,
                 observacions: observ,
                 ordre: ordre,
                 id_grup : id_grup
            })
        });
            const jsonData = await response.json();
            return jsonData;

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
